import { PriceDetailMapper } from '../Price/PriceDetailMapper.js';

class CommonProductMapper {
  static createModelFromResponse(response) {
    if (!response) {
      return undefined;
    }
    return {
      ...PriceDetailMapper.createModelFromResponse(response),
      isEnabled: response.is_enabled,
      isSelected: response.is_selected
    };
  }
}
class ProductsMapper {
  static createModelFromResponse(response) {
    var _response$insurance$p, _response$insurance$p2;
    return {
      insurance: response.insurance ? {
        ...CommonProductMapper.createModelFromResponse(response.insurance),
        insuranceType: response.insurance.insurance_type,
        protection: {
          protectionType: (_response$insurance$p = response.insurance.protection) === null || _response$insurance$p === void 0 ? void 0 : _response$insurance$p.protection_type,
          value: (_response$insurance$p2 = response.insurance.protection) === null || _response$insurance$p2 === void 0 ? void 0 : _response$insurance$p2.value
        }
      } : undefined,
      cashOnDelivery: response.cash_on_delivery ? {
        ...CommonProductMapper.createModelFromResponse(response.cash_on_delivery),
        amount: response.cash_on_delivery.amount,
        maxAmount: response.cash_on_delivery.max_amount
      } : undefined,
      additionalHandling: CommonProductMapper.createModelFromResponse(response.additional_handling),
      adultSignature: CommonProductMapper.createModelFromResponse(response.adult_signature),
      porterage: CommonProductMapper.createModelFromResponse(response.porterage),
      proofOfDelivery: CommonProductMapper.createModelFromResponse(response.proof_of_delivery),
      voucher: response.voucher ? {
        ...CommonProductMapper.createModelFromResponse(response.voucher),
        name: response.voucher.name,
        percentage: response.voucher.percentage
      } : undefined,
      managementFee: CommonProductMapper.createModelFromResponse(response.management_fee),
      priority: CommonProductMapper.createModelFromResponse(response.priority)
    };
  }
}

export { CommonProductMapper, ProductsMapper };
//# sourceMappingURL=ProductsMapper.js.map
